<template>
  <div>

    <v-btn
      @click.native="selectFile"
      v-if="!uploadEnd && !uploading"
      icon
      large
      >
        <v-icon>mdi-image-plus</v-icon>
    </v-btn>
    <form ref="form">
      <input
      id="files"
      type="file"
      name="file"
      ref="uploadInput"
      accept="image/*"
      :multiple="false"
      @change="detectFiles($event)" />
    </form>
      <v-progress-circular
        v-if="uploading && !uploadEnd"
        :size="100"
        :width="15"
        :rotate="360"
        :value="progressUpload"
        color="primary">
        %
      </v-progress-circular>
      <img
        :imageId="parsedImageId"
        v-if="uploadEnd"
        :src="downloadURL"
        width="50%" />
      <div v-if="uploadEnd">
        <v-btn
          class="ma-0"
          dark
          large
          icon
          color="error"
          @click="deleteImage()"
          >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
      <span class="white--text">{{parsedImageId}}</span>
  </div>
</template>

<script>
//var result = string.split('%2F')[1].split('?')[0] formulate to parse google URLs

import firebase from 'firebase'
import uuid from 'uuid/v4'
var firestorage = firebase.storage();

export default {
  props: ['existingCard'],
  computed: {
    parsedImageId() {
      if (this.existingCard != "") {
        let parsed = this.existingCard.split('%2F')[1].split('?')[0]
        this.uploadEnd = true
        this.downloadURL = this.existingCard
        this.fileid = parsed
        return parsed
      }
      else {
        return null
      }
    }
  },
  data () {
    return {
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      uploading: false,
      uploadEnd: false,
      downloadURL: '',
      fileid: uuid()
    }
  },
   methods: {
    resetComponent() {
      this.uploading = false
      this.uploadEnd = false
      this.downloadURL = ''
      this.fileid = uuid()
    },
    selectFile () {
      this.$refs.uploadInput.click()
    },
    detectFiles (e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload (file) {
      this.fileName = file.name
      this.uploading = true
      this.uploadTask = firestorage.ref('images/' + this.fileid).put(file)
      console.log(this.uploadTask)
    },
    deleteImage () {
//make it so delete image doesn't actually remove the image
      // firestorage
      //   .ref('images/' + this.fileid)
      //   .delete()
      //   .then(() => {
      //     this.uploading = false
      //     this.uploadEnd = false
      //     this.downloadURL = ''
      //   })
      //   .catch((error) => {
      //     console.error(`file delete error occured: ${error}`)
      //   })
      //fix paramas
      this.uploading = false
      this.uploadEnd = false
      this.downloadURL = ''
      //fix params

      this.$emit('downloadURL', "")
      this.$refs.form.reset()
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.uploadEnd = true
          this.downloadURL = downloadURL
          this.$emit('downloadURL', downloadURL)
        })
      })
    }
  }
}
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0,0,0,0);
}
</style>
